export default "__VITE_ASSET__d16f0a3f__"